import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { FallingMoney } from './components/FallingMoney';
import { StickyCTA } from './components/StickyCTA';
import { CurrencyProvider } from './hooks/CurrencyContext';
const WhatIsAntiImpulso = lazy(() => import('./components/WhatIsAntiImpulso').then(m => ({
  default: m.WhatIsAntiImpulso
})));
const WhoIsItFor = lazy(() => import('./components/WhoIsItFor').then(m => ({
  default: m.WhoIsItFor
})));
const WhyItFails = lazy(() => import('./components/WhyItFails').then(m => ({
  default: m.WhyItFails
})));
const Mechanism = lazy(() => import('./components/Mechanism').then(m => ({
  default: m.Mechanism
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Expectations = lazy(() => import('./components/Expectations').then(m => ({
  default: m.Expectations
})));
const TargetAudience = lazy(() => import('./components/TargetAudience').then(m => ({
  default: m.TargetAudience
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FooterCTA = lazy(() => import('./components/FooterCTA').then(m => ({
  default: m.FooterCTA
})));
export function App() {
  return <CurrencyProvider data-id="element-0">
      <div className="min-h-screen w-full bg-[#FFF5F0] overflow-x-hidden relative" data-id="element-1">
        <FallingMoney data-id="element-2" />
        <div className="relative" style={{
        zIndex: 1
      }} data-id="element-3">
          <Hero data-id="element-4" />
          <Suspense fallback={null} data-id="element-5">
            <WhatIsAntiImpulso data-id="element-6" />
            <WhoIsItFor data-id="element-7" />
            <WhyItFails data-id="element-8" />
            <Mechanism data-id="element-9" />
            <WhatYouGet data-id="element-10" />
            <Expectations data-id="element-11" />
            <TargetAudience data-id="element-12" />
            <FAQ data-id="element-13" />
            <FooterCTA data-id="element-14" />
          </Suspense>
        </div>
        <StickyCTA data-id="element-15" />
      </div>
    </CurrencyProvider>;
}